import {
  AddressBasedTemplateDetailPage,
  type AddressBasedTemplatePageConfig,
} from "../check-arguments-templates-shared";

const config: AddressBasedTemplatePageConfig = {
  apiPathPrefix: "civil-litigation",
  settingsPathPrefix: "civil-litigation-templates",
  templateLabel: (t) => t("Civil Litigation"),
  testIdPrefix: "civil-litigation-template",
};

export function CivilLitigationTemplateDetailPage() {
  return <AddressBasedTemplateDetailPage config={config} />;
}
